import ApiClient from './ApiClient';

class BranchesAPI extends ApiClient {
  constructor() {
    super('branches', { accountScoped: true });
  }

  getTransferable() {
    return window.axios.get(this.url, { params: { purpose: 'transfer' } });
  }

  getAgents({ branchId }) {
    return window.axios.get(`${this.url}/${branchId}/branch_members`);
  }

  addAgents({ branchId, agentsList }) {
    return window.axios.post(`${this.url}/${branchId}/branch_members`, {
      user_ids: agentsList,
    });
  }

  updateAgents({ branchId, agentsList }) {
    return window.axios.patch(`${this.url}/${branchId}/branch_members`, {
      user_ids: agentsList,
    });
  }

  deleteAgent({ branchId, agentId }) {
    return window.axios.delete(`${this.url}/${branchId}/branch_members`, {
      data: { user_ids: [agentId] },
    });
  }

  getTeams({ branchId }) {
    return window.axios.get(`${this.url}/${branchId}/branch_teams`);
  }

  updateTeams({ branchId, teamsList }) {
    return window.axios.patch(`${this.url}/${branchId}/branch_teams`, {
      team_ids: teamsList,
    });
  }
}

export default new BranchesAPI();
